import 'bootstrap';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/scrollspy';

import axios from 'axios';
import jQuery from 'jquery';
import Vue from 'vue';

import { dom, library as fa_lib } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import FixedOnScroll from './classes/fixed-on-scroll';
import { Initializer } from './interfaces/general';

dom.watch(); // This will kick of the initial replacement of i to svg tags and configure a MutationObserver (fontawesome)

fa_lib.add(fas);
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;

export const boot = (initializers: Initializer[], app: Vue) => {
  jQuery($ => {
    initializers.forEach(initializer => {
      initializer.mount($, app);
    });
  });
};
